import { render, staticRenderFns } from "./CatalogoAccesos.vue?vue&type=template&id=8ea5bb6e&scoped=true&"
import script from "./CatalogoAccesos.vue?vue&type=script&lang=js&"
export * from "./CatalogoAccesos.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/globals.css?vue&type=style&index=0&id=8ea5bb6e&scoped=true&lang=css&"
import style1 from "./CatalogoAccesos.vue?vue&type=style&index=1&id=8ea5bb6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ea5bb6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCol,VRow,VTextField})
